import { h, Host } from "@stencil/core";
import { ICON_NAMESPACE } from "../../icons/namespace";
/** Display a row of five pulsing dots, to indicate loading. */
export class LoadingDots {
    render() {
        return (h(Host, { key: 'f3faa2c85a0e20fd907cf7fc0e0c9fc889a64485' }, h("es-icon", { key: '6b6bfd7f1d06dbfcbf4521f0637e2e8469038ede', icon: [ICON_NAMESPACE, 'dot'], size: 14 }), h("es-icon", { key: '8496a186423789e8b1c5564f2c323d5b82ea2731', icon: [ICON_NAMESPACE, 'dot'], size: 14 }), h("es-icon", { key: '6fb9f42da1429d2312c0a9c44c7af3f116b591de', icon: [ICON_NAMESPACE, 'dot'], size: 14 }), h("es-icon", { key: 'a39ec024f336dd89ac4896ced171dc1720af2724', icon: [ICON_NAMESPACE, 'dot'], size: 14 }), h("es-icon", { key: '9247819b1da08c6fdb364e0cfc8c38dc860a514f', icon: [ICON_NAMESPACE, 'dot'], size: 14 })));
    }
    static get is() { return "es-loading-dots"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["es-loading-dots.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["es-loading-dots.css"]
        };
    }
}
//# sourceMappingURL=es-loading-dots.js.map
